/**
 * Error handling type definitions
 */

export enum ErrorCategory {
	/** Network failures, timeouts */
	NETWORK = "NETWORK",
	/** 401, 403 - Authentication/authorization */
	AUTH = "AUTH",
	/** 422 - Field validation errors */
	VALIDATION = "VALIDATION",
	/** 400, 409 - Business logic errors */
	BUSINESS = "BUSINESS",
	/** 404 - Resource not found */
	NOT_FOUND = "NOT_FOUND",
	/** 500, 503 - Server errors */
	SERVER = "SERVER",
	/** Unknown/unexpected errors */
	UNKNOWN = "UNKNOWN",
}

export interface FieldError {
	field: string;
	message: string;
}

export interface AppError {
	/** User-friendly error message */
	message: string;
	/** Error category for handling logic */
	category: ErrorCategory;
	/** HTTP status code (if applicable) */
	status?: number;
	/** Error code from API */
	code?: string;
	/** Field-level validation errors */
	fieldErrors?: FieldError[];
	/** Whether this error should trigger a retry */
	retryable: boolean;
	/** Original error for debugging */
	originalError?: unknown;
}

export interface ErrorDisplayProps {
	error: AppError;
	onRetry?: () => void;
	showDetails?: boolean;
}
